<div class="performer-dialog">
  <div class="dialog-header">
    <h2>{{ dialogTitle }}</h2>
    <button mat-icon-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="performerForm" class="performer-form">
      <!-- Performer ID and Name Row -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Performer Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter performer name" />
          @if (performerForm.get('name')?.touched &&
          performerForm.get('name')?.hasError('required')) {
          <mat-error>
            {{ getErrorMessage('name') }}
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Referral Group -->
      @if (!data.isRoleBasedUser || (data.isRoleBasedUser && data.userReferralGroupId)) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Referral Group</mat-label>
        <mat-select
          formControlName="referralGroup"
          [disabled]="data.isEdit || (data.isRoleBasedUser && data.userReferralGroupId)"
        >
          @for (group of data.referralGroups; track group) {
          <mat-option [value]="group.value">
            {{ group.label }}
          </mat-option>
          }
        </mat-select>
        @if (performerForm.get('referralGroup')?.touched &&
        performerForm.get('referralGroup')?.hasError('required')) {
        <mat-error>
          {{ getErrorMessage('referralGroup') }}
        </mat-error>
        }
      </mat-form-field>
      }

      <!-- Terms and Conditions Checkboxes -->
      @if (!data.isEdit) {
      <div class="agreements-section">
        <div class="agreement-item">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="agreeTerms" class="checkbox-input" />
            <span class="checkmark"></span>
            <span class="checkbox-text"
              >I agree to the Medmate Terms and Conditions and Medmate Privacy Policy</span
            >
          </label>
          @if (performerForm.get('agreeTerms')?.touched &&
          performerForm.get('agreeTerms')?.hasError('required')) {
          <div class="checkbox-error">Required</div>
          }
        </div>
        <div class="agreement-item">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="agreeReferrals" class="checkbox-input" />
            <span class="checkmark"></span>
            <span class="checkbox-text"
              >I agree to send e-Referrals to
              {{ selectedReferralGroupName || '[Selected Group]' }} Radiology Network</span
            >
          </label>
          @if (performerForm.get('agreeReferrals')?.touched &&
          performerForm.get('agreeReferrals')?.hasError('required')) {
          <div class="checkbox-error">Required</div>
          }
        </div>
      </div>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!performerForm.valid || isSubmitting"
      (click)="onSave()"
    >
      @if (isSubmitting) {
      <mat-spinner diameter="16" style="margin-right: 8px"></mat-spinner>
      }
      {{ saveButtonText }}
    </button>
  </mat-dialog-actions>
</div>
